"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaAssetsGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var react_dropzone_1 = require("react-dropzone");
var react_redux_1 = require("react-redux");
var create_media_asset_1 = require("../../../../../../api/calls/client/client-media/create_media_asset");
var upload_file_1 = require("../../../../../../api/calls/media/upload_file");
var delete_1 = require("../../../../../../components/icons/delete");
var eye_1 = require("../../../../../../components/icons/eye");
var upload_1 = require("../../../../../../components/icons/upload");
var get_client_media_assets_thunk_1 = require("../../../../../../reducers/slices/client/thunks/get_client_media_assets_thunk");
var main_1 = require("../../../../../../reducers/slices/main");
var media_asset_view_1 = require("./media_asset_view");
var MediaAssetsGrid = function (_a) {
    var onDelete = _a.onDelete, onSelectionChange = _a.onSelectionChange;
    var _b = (0, react_2.useState)(false), isUploading = _b[0], setIsUploading = _b[1];
    var _c = (0, react_2.useState)(new Set()), selectedFiles = _c[0], setSelectedFiles = _c[1];
    var _d = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }), mediaAssets = _d.mediaAssets, pagination = _d.pagination;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var dispatch = (0, react_redux_1.useDispatch)();
    var loadMediaAssets = function (query) {
        if (query === void 0) { query = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch((0, get_client_media_assets_thunk_1.get_client_media_assets_thunk)(__assign(__assign(__assign({}, query), pagination), { order_by: -1 })));
                return [2 /*return*/];
            });
        });
    };
    (0, react_2.useEffect)(function () {
        loadMediaAssets();
    }, []);
    var handleView = function (mediaAsset) {
        dispatch((0, main_1.setContentModal)({
            title: mediaAsset.file_name,
            content: (0, jsx_runtime_1.jsx)(media_asset_view_1.MediaAssetView, { mediaAsset: mediaAsset, onDelete: onDelete }),
        }));
    };
    var handleSelectionChange = function (mediaId) {
        var newSelectedFiles = new Set(selectedFiles);
        if (newSelectedFiles.has(mediaId)) {
            newSelectedFiles.delete(mediaId);
        }
        else {
            newSelectedFiles.add(mediaId);
        }
        setSelectedFiles(newSelectedFiles);
    };
    var onDrop = (0, react_2.useCallback)(function (acceptedFiles) { return __awaiter(void 0, void 0, void 0, function () {
        var uploadPromises, results, successfulUploads, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsUploading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    uploadPromises = acceptedFiles.map(function (file) {
                        var type = "IMAGE";
                        if (file.type.startsWith("video/")) {
                            type = "VIDEO";
                        }
                        else if (file.type.startsWith("application/")) {
                            type = "DOCUMENT";
                        }
                        return (0, upload_file_1.upload_file)({
                            file: file,
                            file_name: file.name,
                            description: "Media asset upload",
                            type: type,
                            category: "ASSET",
                        });
                    });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 2:
                    results = _a.sent();
                    successfulUploads = results
                        .map(function (res, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var originalFile;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(res === null || res === void 0 ? void 0 : res.success)) return [3 /*break*/, 2];
                                    originalFile = acceptedFiles[index];
                                    return [4 /*yield*/, (0, create_media_asset_1.create_media_asset)({
                                            url: res.content.location,
                                            etag: res.content.etag || "",
                                            file_name: res.content.file_name,
                                            file_type: originalFile.type,
                                            file_size: originalFile.size,
                                            uploaded_by: user._id,
                                            metadata: {
                                                title: res.content.file_name,
                                                alt_text: res.content.file_name,
                                                description: "Media asset upload",
                                                copyright: "none",
                                                width: 0,
                                                height: 0,
                                                color_space: "none",
                                                duration: 0,
                                                fps: 0,
                                                page_count: 0,
                                                author: user === null || user === void 0 ? void 0 : user.name,
                                                format: originalFile.type,
                                            },
                                        })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/, true];
                                case 2: return [2 /*return*/, false];
                            }
                        });
                    }); })
                        .filter(Boolean);
                    if (successfulUploads.length > 0) {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Success",
                            messages: ["Successfully uploaded ".concat(successfulUploads.length, " file(s)")],
                        }));
                    }
                    if (successfulUploads.length !== acceptedFiles.length) {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Warning",
                            messages: ["Failed to upload ".concat(acceptedFiles.length - successfulUploads.length, " file(s)")],
                        }));
                    }
                    dispatch((0, get_client_media_assets_thunk_1.get_client_media_assets_thunk)(__assign({}, pagination)));
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Error",
                        messages: ["An error occurred while uploading files"],
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setIsUploading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var _e = (0, react_dropzone_1.useDropzone)({
        onDrop: onDrop,
        accept: {
            "image/*": [".png", ".jpg", ".jpeg", ".gif"],
            "video/*": [".mp4", ".mov", ".avi"],
            "application/*": [".pdf", ".doc", ".csv"],
        },
        multiple: true,
    }), getRootProps = _e.getRootProps, getInputProps = _e.getInputProps, isDragActive = _e.isDragActive;
    var handleSubmit = function () {
        if (onSelectionChange) {
            onSelectionChange(Array.from(selectedFiles));
            setSelectedFiles(new Set());
        }
    };
    if (!mediaAssets.length) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "w-full h-[400px] flex items-center justify-center" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({}, getRootProps(), { className: "w-full h-full max-w-2xl border-2 border-dashed rounded-lg p-8 flex flex-col items-center justify-center gap-4 cursor-pointer transition-colors\n            ".concat(isDragActive ? "border-primary bg-primary/10" : "border-default-300 hover:border-primary") }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({}, getInputProps())), isUploading ? ((0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(upload_1.UploadIcon, { className: "w-12 h-12 text-default-400" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "text-center" }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "text-lg font-semibold" }, { children: "Drag & drop files here" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm text-default-400" }, { children: "or click to select files" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-xs text-default-400 mt-2" }, { children: "Supported formats: Images (PNG, JPG, GIF), Videos (MP4, MOV, AVI), Documents (PDF, Doc, CSV)" }))] }))] }))] })) })));
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({}, getRootProps(), { className: "w-full h-[100px] border-2 border-dashed rounded-lg p-4 flex items-center justify-center gap-4 cursor-pointer transition-colors\n          ".concat(isDragActive ? "border-primary bg-primary/10" : "border-default-300 hover:border-primary") }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({}, getInputProps())), isUploading ? ((0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(upload_1.UploadIcon, { className: "w-8 h-8 text-default-400" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "text-center" }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm font-semibold" }, { children: "Drag & drop files here" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-xs text-default-400" }, { children: "or click to select files" }))] }))] }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 py-4 w-[60vw]" }, { children: mediaAssets.map(function (mediaAsset) { return ((0, jsx_runtime_1.jsx)(react_1.Card, __assign({ isHoverable: true, isPressable: true }, { children: (0, jsx_runtime_1.jsx)(react_1.CardBody, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-1 relative" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Checkbox, { className: "absolute top-2 right-2 z-20", isSelected: selectedFiles.has(mediaAsset._id), onValueChange: function () { return handleSelectionChange(mediaAsset._id); } }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-1" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Image, { src: mediaAsset.url, alt: mediaAsset.metadata.alt_text || mediaAsset.file_name, height: 80, width: "100%", className: "rounded-md mb-2", style: { objectFit: "contain" } }), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-bold text-small capitalize" }, { children: mediaAsset.file_name })), mediaAsset.metadata.title && (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-tiny text-default-400" }, { children: mediaAsset.metadata.title }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "absolute bottom-1 rounded border-1 right-1 z-20 bg-white p-1" }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ className: "text-blue-500 hover:text-blue-700 p-2 rounded-full transition-colors", title: "View Details", onClick: function () { return handleView(mediaAsset); } }, { children: (0, jsx_runtime_1.jsx)(eye_1.EyeFilledIcon, { className: "cursor-pointer text-default-400", height: 18, width: 18 }) })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "text-red-500 hover:text-red-700 p-2 rounded-full transition-colors", title: "Delete Media", onClick: function () { return onDelete(mediaAsset._id); } }, { children: (0, jsx_runtime_1.jsx)(delete_1.DeleteFilledIcon, { className: "cursor-pointer text-default-400", height: 18, width: 18 }) }))] }))] })) }) }), mediaAsset._id)); }) })), selectedFiles.size > 0 && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-end" }, { children: (0, jsx_runtime_1.jsxs)(react_1.Button, __assign({ color: "primary", onPress: handleSubmit, className: "px-4" }, { children: ["Submit Selected (", selectedFiles.size, ")"] })) })))] })));
};
exports.MediaAssetsGrid = MediaAssetsGrid;
